import React from "react";
import { PuffLoader } from "react-spinners";
import SingleCheapAdvertCard from "./SingleCheapAdvertCard";
import useEmlakjetProperties from "../../hooks/useEmlakjetProperties";
import "../home/home-listings.css";

const AdvertCardListThree = () => {
  const { data } = useEmlakjetProperties();

  if (!data || data.length === 0) {
    return (
      <div className="wrapper flexCenter" style={{ height: "60vh" }}>
        <PuffLoader
          height="80"
          width="80"
          radius={1}
          color="#c5955b"
          aria-label="puff-loading"
        />
      </div>
    );
  }

  return (
    <div className="px-[3%] md:px-[6%] overflow-x-hidden max-w-full">
      <div className="pt-10 pb-16 home-listings-section">
        <div className="text-center">
          <a href="/adverts">
            <h1 className="mx-auto sub-heading">TÜMÜNÜ GÖR</h1>
          </a>
          <h1 className="heading">Listelenen Yeni İlanlar</h1>
        </div>
        <div className="home-listings-flex mt-8 items-stretch">
          {data.slice(0, 4).map((card) => (
            <SingleCheapAdvertCard
              card={card}
              key={card.id}
              className="w-full min-w-0 max-w-full h-full shadow-light dark:border-card-dark border rounded-lg overflow-hidden relative group"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdvertCardListThree;
